import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from 'theme/Button';
import Icon from 'theme/Icon';
import Spinner from 'theme/Spinner';
import toggleClass from 'theme/dom/toggleClass';
import { setSelectedCategory } from 'actions/navigation';

import { Tree } from 'antd';

const { TreeNode, DirectoryTree } = Tree;

const $ST = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/menu.json`);

const $R = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/routes`);

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

class Menu extends React.Component {
  constructor(props) {
    super(props);

    const { depth } = props;
    let depthObjects = [];

    for (let i = 0; i < depth; i++) {
      depthObjects.push({
        id: i,
        isActive: !i,
        currentParentPk: '',
      });
    }

    this.state = {
      scenes: depthObjects,
      treeData: [],
    };
  }

  componentDidUpdate(prevProps, prevstate) {
    if (this.props.menuItems !== prevProps.menuItems) {
      let treeData = [];
      if (['TFS', 'NAUTICA'].includes($A.BRAND) && this.props.menuItems.length > 0) {
        let instoreMenus = this.isShownInstore();
        treeData = this.generateTree(instoreMenus);
      } else {
        treeData = this.generateTree(this.props.menuItems);
      }
      this.setState({ treeData });
    }
  }

  goToHome() {
    const { scenes } = this.state;

    toggleClass({
      elId: 'js-navigation',
      className: 'active',
    });
    toggleClass({ elId: 'js-menu', className: 'active' });

    scenes.forEach((item) => {
      item.isActive = false;
      if (item.id === 0) {
        item.isActive = true;
      }
    });

    this.setState({ scenes });
  }

  isShownInstore() {
    const menusForInstore = this.props.menuItems.filter((item) =>
      item.extra_context.attributes.show_in_instore !== undefined
        ? item.extra_context.attributes.show_in_instore.kwargs.value === 'yes'
        : []
    );
    return menusForInstore;
  }

  //https://stackoverflow.com/questions/18017869/build-tree-array-from-flat-array-in-javascript
  generateTree = (list) => {
    let map = {},
      node,
      roots = [],
      i;

    for (i = 0; i < list.length; i++) {
      map[list[i].pk] = i; // initialize the map
      list[i].children = []; // initialize the children
      list[i].key = list[i].pk;
      list[i].title = list[i].label;
    }
    
    for (i = 0; i < list.length; i++) {
      node = list[i];
      if (node.level !== 0) {
        if (node.parent_pk !== null && node.parent_pk !== undefined) {
          list[map[node.parent_pk]] !== undefined && list[map[node.parent_pk]].children.push(node);
        } else {
          roots.push(node);
        }
      } else {
        roots.push(node);
      }
    }
    return roots;
  };

  onChangeSelectedCategory = (pk) => {
    const { dispatch } = this.props;
    dispatch(setSelectedCategory(pk));
  };

  renderTreeNodes = (tree) => {
    return (
      tree.length &&
      tree.map(({ children, key, title, url, level }) => {
        const PlusIcon = () => (children.length ? <Icon icon='arti' /> : '');
        const dynamicTitle =
          level || !children.length ? (
            <Link
              onClick={() => this.onChangeSelectedCategory(key)}
              to={$R.PRODUCT_LIST.path + url}
            >
              {title}
              <PlusIcon />
            </Link>
          ) : (
            <React.Fragment>
              {title}
              <PlusIcon />
            </React.Fragment>
          );
        return (
          <TreeNode title={dynamicTitle} key={key}>
            {children.length && this.renderTreeNodes(children)}
          </TreeNode>
        );
      })
    );
  };

  render() {
    const { props, state, goToHome } = this;
    const { pending } = props;
    const { treeData } = state;

    return pending ? (
      <Spinner />
    ) : (
      <div className='menu' id='js-menu'>
        <div className='menu-header'>
          <ul>
            <li className='header'>
              <Button classes='pointer' onClick={goToHome.bind(this)}>
                <Icon icon='home' /> {$ST.HOME}
              </Button>
            </li>
          </ul>
        </div>
        <div className='menu-tree-view'>
          <DirectoryTree>
            {treeData.length && this.renderTreeNodes(treeData)}
          </DirectoryTree>
        </div>
      </div>
    );
  }
}

export default connect(null)(Menu);



// WEBPACK FOOTER //
// ./src/components/partials/Menu.js